import { render, staticRenderFns } from "./LayerIcon.vue?vue&type=template&id=22e2aeca"
import script from "./LayerIcon.vue?vue&type=script&lang=js"
export * from "./LayerIcon.vue?vue&type=script&lang=js"
import style0 from "./LayerIcon.vue?vue&type=style&index=0&id=22e2aeca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports